import React from 'react';

const GridLayout = ({ content }) => (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {content.main.content.split('\n\n').map((paragraph, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
                <p className="text-gray-700">{paragraph}</p>
            </div>
        ))}
    </div>
);

export default GridLayout;